import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import ResidentDetailsTab from "../AddResident/ResidentDetailsTab";
import { useNavigate } from "react-router-dom";
// import AddResidentNewTab from "./AddResidentNewTab";
// import Loader from "../../../assets/Images/loader.gif";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AddResident() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ResidentManagement2")}
              />{" "}
              Add Resident
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Add Resident</div>
            <div className="residentContMain residentTabOut">
              <ResidentDetailsTab />
            </div>
          </Grid>
        </Grid>
      </div>
      {/* <div className="loaderOut" >
        <div className="loaderBox" ><img src={Loader}/></div>
      </div>  */}
    </>
  );
}

export default AddResident;
